import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { Img } from 'containers/misc'
import { get } from 'lodash'

import styles from './assessor-participant-info.styl'

export default class AssessorParticipantInfo extends Component {
  static propTypes = {
    children: PropTypes.any,
    activity: PropTypes.object
  }

  static defaultProps = {
    query: {}
  }

  render() {
    const { activity } = this.props

    return (
      <div className={styles.row}>
        <div className={styles.imageWrap}>
          {get(activity, 'award.participant.photoUrl') ? (
            <Img
              className={styles.profileImage}
              src={activity.award.participant.photoUrl}
              alt="Profile photo"
              withCode
            />
          ) : (
            <div className={styles.image}>
              <span className={`ico ico--user ${styles.ico}`} />
            </div>
          )}
        </div>
        <div className={styles.infoWrap}>
          <h2 className={styles.name}>
            {get(activity, 'award.participant.title')
              ? `${activity.award.participant.title}. `
              : ''}
            {get(activity, 'award.participant.firstName')}&nbsp;
            {get(activity, 'award.participant.lastName')}
          </h2>
          <p className={styles.paragraph}>
            {get(activity, 'award.organization.name')} -{' '}
            {get(activity, 'award.organization.country.name')}
          </p>
          <p className={styles.paragraph}>
            {get(activity, 'award.awardLevel.translationText')}
            &nbsp;
            {get(activity, 'award.startDate') && (
              <span>
                <FormattedMessage
                  id="assessor_participant_info.startDate"
                  defaultMessage="award started on"
                />
                {' - '}
                <FormattedDate value={activity.award.startDate} />
              </span>
            )}{' '}
          </p>
          <div className={styles.tableWrap}>{this.props.children}</div>
        </div>
      </div>
    )
  }
}
